import Link from 'next/link';
import Icon from'@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

export default function Footer() {
  const currentYear = 2026

  return (
    <footer className="border-t border-border bg-background">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 mb-8">
          {/* Logo & Description */}
          <Link href="/homepage" className="flex items-center gap-3 group">
            <div className="w-24 h-24 flex items-center justify-center">
              <AppImage 
                src="/assets/images/East_Coast_Sticker_Logo-1786121660508.png" 
                alt="East Coast Underground Logo" 
                className="w-24 h-24 object-contain"
              />
            </div>
            <div>
              <h3 className="text-lg font-bold text-foreground group-hover:text-primary transition-colors">East Coast Underground</h3>
              <p className="text-xs text-muted-foreground">Horizontal Directional Drilling Experts</p>
            </div>
          </Link>
          
          {/* Navigation Links + Social - aligned right */}
          <div className="flex items-center gap-8">
            <nav className="flex flex-wrap items-center justify-end gap-8">
              <Link 
                href="/contact" 
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                Contact
              </Link>
              <Link 
                href="/careers" 
                className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors"
              >
                Careers
              </Link>
            </nav>
            <a 
              href="https://linkedin.com" 
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              <Icon name="ShareIcon" size={20} />
            </a>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            © {currentYear} East Coast Underground. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <Link 
              href="/homepage" 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy Policy
            </Link>
            <Link 
              href="/homepage" 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms of Service
            </Link>
            <Link 
              href="/admin/login" 
              className="text-sm font-semibold text-muted-foreground border border-border hover:bg-muted hover:text-foreground transition-colors px-3 py-1 rounded-lg"
            >
              Admin Login
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}